import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { SharebeltContext } from '../../Sharebelt.context';
import { track } from '../../../analytics';

const ShareBeltPrint = () => {

  const {
    channel
  } = useContext(ExperienceContext);

  const onClickPrint = useCallback((event) => {
    event.preventDefault();
    track({
      component: 'system',
      eventName: 'pip sub-content',
      primaryCategory: 'interaction',
      section: 'sharing',
      target: 'print'
    });
    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
      window.print();
    }
  }, []);

  const {
    horizontal,
    vertical
  } = useContext(SharebeltContext);

  const shareBeltButtonClasses = classNames('thd-sharebelt__button', {
    'thd-sharebelt__button--vertical': vertical,
    'thd-sharebelt__button--horizontal': horizontal
  });
  const shareBeltIconClasses = classNames('thd-sharebelt-icons', 'thd-sharebelt-icons--print', {
    'thd-sharebelt-icons--vertical': vertical,
    'thd-sharebelt-icons--horizontal': horizontal
  });

  // @todo check mobile requirements
  if (channel.toLowerCase() !== 'desktop') {
    return (
      <div className="thd-sharebelt__item" />
    );
  }
  return (
    <div className="thd-sharebelt__item">
      <button
        className={shareBeltButtonClasses}
        data-component="system"
        data-target="print"
        name="print-page"
        onClick={onClickPrint}
        type="button"
      >
        <span className={shareBeltIconClasses}>
          print
        </span>
        <span>Print</span>
      </button>
    </div>
  );
};

ShareBeltPrint.displayName = 'ShareBeltPrint';

export default ShareBeltPrint;
